import { useEffect, useState } from 'react';
import ExtractedDataTable from './ExcelExtractedDataTable';
import { getQrCode } from '../views/qrCodes/getQrCode';
import { useLocation } from 'react-router-dom';
import { ExcelData } from './ExcelData';

const ShowQrCode: React.FC = () => {
  const [excelData, setExcelData] = useState<any>(null); // Stores the extracted Excel data
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codice = queryParams.get('qrCode');

  useEffect(() => {
    const fetchExcelData = async () => {
      const res: Response = await getQrCode(codice || '');
      const getProjectData = await res.json();
      if (res.ok) {
        const js: ExcelData = getProjectData.returnValue.rows[0];
        setExcelData(js);
      } else {
        alert(getProjectData.message);
      }
    };
    fetchExcelData();
  }, [codice]);

  return (
    <div>
      <ExtractedDataTable excelData={excelData} />
    </div>
  );
};

export default ShowQrCode;
